/* Schema-driven admin editors for content collections. */

export const COLLECTIONS = {
  services: {
    api: "/admin/services",
    title: "Services",
    singular: "Service",
    listCols: [
      { key: "number", label: "#" },
      { key: "title", label: "Title" },
      { key: "slug", label: "Slug" },
    ],
    fields: [
      { key: "title", label: "Title", type: "text" },
      { key: "slug", label: "Slug", type: "text", hint: "URL path segment" },
      { key: "number", label: "Number", type: "text", hint: "e.g. 01" },
      { key: "order", label: "Order", type: "number" },
      { key: "visible", label: "Visible on public site", type: "toggle", default: true },
      { key: "icon", label: "Icon key", type: "select", options: ["livestock", "lab", "research", "training", "certification", "quality"] },
      { key: "summary", label: "Summary (card text)", type: "textarea" },
      { key: "hero_eyebrow", label: "Hero eyebrow", type: "text" },
      { key: "hero_lead", label: "Hero lead", type: "textarea" },
      { key: "overview", label: "Overview paragraphs", type: "stringlist" },
      { key: "challenges", label: "Challenges addressed", type: "objlist", itemFields: [{ key: "title", label: "Title" }, { key: "description", label: "Description", type: "textarea" }] },
      { key: "scope", label: "Scope of support", type: "stringlist" },
      { key: "process", label: "Process steps", type: "objlist", itemFields: [{ key: "number", label: "No." }, { key: "title", label: "Title" }, { key: "description", label: "Description", type: "textarea" }] },
      { key: "deliverables", label: "Expected deliverables", type: "stringlist" },
      { key: "benefits", label: "Client benefits", type: "stringlist" },
      { key: "industries", label: "Relevant industry slugs", type: "stringlist", hint: "e.g. food-agriculture" },
      { key: "related", label: "Related service slugs", type: "stringlist" },
      { key: "faqs", label: "FAQs", type: "objlist", itemFields: [{ key: "q", label: "Question" }, { key: "a", label: "Answer", type: "textarea" }] },
      { key: "image_media_id", label: "Hero photo", type: "media" },
      { key: "image_alt", label: "Hero photo alt text", type: "text" },
      { key: "secondary_media_id", label: "Secondary photo 1", type: "media" },
      { key: "secondary_alt", label: "Secondary photo 1 alt text", type: "text" },
      { key: "secondary2_media_id", label: "Secondary photo 2", type: "media" },
      { key: "secondary2_alt", label: "Secondary photo 2 alt text", type: "text" },
    ],
  },
  industries: {
    api: "/admin/industries",
    title: "Industries",
    singular: "Industry",
    listCols: [
      { key: "number", label: "#" },
      { key: "title", label: "Title" },
      { key: "slug", label: "Slug" },
    ],
    fields: [
      { key: "title", label: "Title", type: "text" },
      { key: "slug", label: "Slug", type: "text" },
      { key: "number", label: "Number", type: "text" },
      { key: "order", label: "Order", type: "number" },
      { key: "visible", label: "Visible on public site", type: "toggle", default: true },
      { key: "icon", label: "Icon key", type: "select", options: ["health", "food", "energy", "public"] },
      { key: "summary", label: "Summary (card text)", type: "textarea" },
      { key: "hero_lead", label: "Hero lead", type: "textarea" },
      { key: "clients", label: "Who we serve", type: "stringlist" },
      { key: "challenges", label: "Sector challenges", type: "stringlist" },
      { key: "support", label: "How we support", type: "objlist", itemFields: [{ key: "title", label: "Title" }, { key: "description", label: "Description", type: "textarea" }] },
      { key: "services", label: "Relevant service slugs", type: "stringlist" },
      { key: "image_media_id", label: "Hero photo", type: "media" },
      { key: "image_alt", label: "Hero photo alt text", type: "text" },
      { key: "secondary_media_id", label: "Secondary photo", type: "media" },
      { key: "secondary_alt", label: "Secondary photo alt text", type: "text" },
    ],
  },
  compliance: {
    api: "/admin/compliance",
    title: "Compliance",
    singular: "Compliance page",
    listCols: [
      { key: "tag", label: "Tag" },
      { key: "title", label: "Title" },
      { key: "slug", label: "Slug" },
    ],
    fields: [
      { key: "title", label: "Title", type: "text" },
      { key: "slug", label: "Slug", type: "text" },
      { key: "tag", label: "Tag", type: "text" },
      { key: "practice", label: "Practice key", type: "text", hint: "healthcare | livestock | assessment | risk" },
      { key: "order", label: "Order", type: "number" },
      { key: "summary", label: "Summary (card text)", type: "textarea" },
      { key: "hero_lead", label: "Hero lead", type: "textarea" },
      { key: "overview", label: "Overview paragraphs", type: "stringlist" },
      { key: "items", label: "Scope items", type: "objlist", itemFields: [{ key: "title", label: "Title" }, { key: "description", label: "Description", type: "textarea" }] },
      { key: "image_media_id", label: "Hero photo", type: "media" },
      { key: "image_alt", label: "Hero photo alt text", type: "text" },
    ],
  },
  faqs: {
    api: "/admin/faqs",
    title: "FAQs",
    singular: "FAQ",
    listCols: [
      { key: "order", label: "#" },
      { key: "question", label: "Question" },
      { key: "category", label: "Category" },
    ],
    fields: [
      { key: "question", label: "Question", type: "text" },
      { key: "answer", label: "Answer", type: "textarea" },
      { key: "category", label: "Category", type: "text", hint: "e.g. General, Services" },
      { key: "order", label: "Order", type: "number" },
    ],
  },
  news: {
    api: "/admin/news",
    title: "Insights & News",
    singular: "Post",
    listCols: [
      { key: "date", label: "Date" },
      { key: "title", label: "Title" },
      { key: "published", label: "Published", type: "bool" },
    ],
    fields: [
      { key: "title", label: "Title", type: "text" },
      { key: "slug", label: "Slug", type: "text" },
      { key: "date", label: "Date", type: "date" },
      { key: "published", label: "Published", type: "toggle", default: false },
      { key: "excerpt", label: "Excerpt", type: "textarea" },
      { key: "body", label: "Body", type: "textarea", rows: 14, hint: "Plain text; blank line = new paragraph" },
      { key: "cover_media_id", label: "Cover image", type: "media" },
    ],
  },
  gallery: {
    api: "/admin/gallery",
    title: "Gallery",
    singular: "Photo",
    listCols: [
      { key: "order", label: "#" },
      { key: "caption", label: "Caption" },
      { key: "alt", label: "Alt text" },
    ],
    fields: [
      { key: "media_id", label: "Photo", type: "media" },
      { key: "caption", label: "Caption", type: "text", hint: "Short descriptive caption, no unverified claims" },
      { key: "alt", label: "Alt text", type: "text", hint: "Describes the image for accessibility & SEO" },
      { key: "order", label: "Order", type: "number" },
    ],
  },
};
